import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { CATEGORY_LABEL } from './paymentsShared';

const ACTION_BADGE = {
  'IVA mancante': 'bg-yellow-100 text-yellow-800 border-yellow-300',
  'Scaduto': 'bg-rose-100 text-rose-800 border-rose-300',
  'Da fatturare': 'bg-orange-100 text-orange-800 border-orange-300',
  'Fatturato non incassato': 'bg-blue-100 text-blue-800 border-blue-300',
  'Saldo non sbloccato': 'bg-zinc-100 text-zinc-800 border-zinc-300',
  'Tutto ok': 'bg-emerald-100 text-emerald-800 border-emerald-300',
};

const FILTERS = [
  { key: 'tutti', label: 'Tutti', m: () => true },
  { key: 'da_fatturare', label: 'Da fatturare', m: (a) => a.action_required === 'Da fatturare' },
  { key: 'fatturato', label: 'Fatturato non incassato', m: (a) => a.action_required === 'Fatturato non incassato' },
  { key: 'non_sbloccato', label: 'Non sbloccato', m: (a) => a.action_required === 'Saldo non sbloccato' },
  { key: 'iva_mancante', label: 'IVA mancante', m: (a) => a.action_required === 'IVA mancante' },
  { key: 'scaduto', label: 'Scaduti', m: (a) => a.action_required === 'Scaduto' },
];

export const PaymentsMovementsRegistry = ({ actions }) => {
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState('tutti');
  const active = FILTERS.find((f) => f.key === filter) || FILTERS[0];
  const filtered = (actions || []).filter(active.m);

  return (
    <Card className="card-abitalo" data-testid="movements-registry">
      <CardHeader className="pb-2">
        <button onClick={() => setOpen((o) => !o)} data-testid="movements-toggle"
          className="w-full flex items-center justify-between">
          <CardTitle className="text-base font-bold text-[#3C3C3C]">
            Tutti i movimenti <span className="text-[#737373] font-normal">({(actions || []).length})</span>
          </CardTitle>
          {open ? <ChevronUp className="w-4 h-4 text-[#737373]" /> : <ChevronDown className="w-4 h-4 text-[#737373]" />}
        </button>
      </CardHeader>
      {open && (
        <CardContent className="p-0">
          <div className="flex gap-1 flex-wrap px-4 pb-3">
            {FILTERS.map((f) => {
              const n = (actions || []).filter(f.m).length;
              return (
                <button key={f.key} onClick={() => setFilter(f.key)} data-testid={`movements-filter-${f.key}`}
                  className={`px-2.5 py-1 text-xs rounded-full border ${filter === f.key ? 'bg-[#FF7819] text-white border-[#FF7819]' : 'bg-white text-[#525252] border-slate-300 hover:border-[#FF7819]'}`}>
                  {f.label}{n > 0 && <span className="ml-1 opacity-80">({n})</span>}
                </button>
              );
            })}
          </div>
          {filtered.length === 0 ? (
            <div className="p-6 text-center text-sm text-[#737373]">Nessun movimento</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-xs" data-testid="movements-table">
                <thead className="bg-slate-50 border-y border-slate-200 text-left text-[#525252] uppercase">
                  <tr>
                    <th className="px-3 py-2">Progetto</th><th className="px-3 py-2">Cliente</th>
                    <th className="px-3 py-2">Categoria</th><th className="px-3 py-2">Descrizione</th>
                    <th className="px-3 py-2 text-right">Netto</th><th className="px-3 py-2 text-center">IVA</th>
                    <th className="px-3 py-2 text-right">Lordo</th><th className="px-3 py-2">Azione</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.slice(0, 300).map((a, i) => (
                    <tr key={`${a.category}-${a.id || i}`} className={`border-b border-slate-100 ${a.vat_warning ? 'bg-yellow-50/40' : ''}`}>
                      <td className="px-3 py-2 whitespace-nowrap font-medium">{a.project_number || '—'}</td>
                      <td className="px-3 py-2 whitespace-nowrap">{a.client_name || '—'}</td>
                      <td className="px-3 py-2"><Badge variant="outline" className="text-[10px]">{CATEGORY_LABEL[a.category] || a.category}</Badge></td>
                      <td className="px-3 py-2 max-w-[220px] truncate" title={a.description}>{a.description || '—'}</td>
                      <td className="px-3 py-2 text-right font-bold whitespace-nowrap tabular-nums">{a.amount_net_formatted}</td>
                      <td className="px-3 py-2 text-center whitespace-nowrap">{a.vat_rate_label}</td>
                      <td className="px-3 py-2 text-right whitespace-nowrap text-[#737373] tabular-nums">{a.amount_gross_formatted}</td>
                      <td className="px-3 py-2 whitespace-nowrap"><Badge className={ACTION_BADGE[a.action_required] || 'bg-slate-100 text-slate-700 border-slate-300'} variant="outline">{a.action_required}</Badge></td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {filtered.length > 300 && <div className="p-2 text-center text-xs text-[#737373]">Mostrate 300 di {filtered.length}</div>}
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
};

export default PaymentsMovementsRegistry;
